import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';

export interface DropdownOption {
    value: any;
    display: string;
  }
  

export interface PopupData {
  header: string;
  message: string;
  userActionType: 'YesOrNo' | 'Confirm';
  dropdownOptions?: DropdownOption[]; // Optional dropdown options
}

@Component({
  selector: 'app-generic-popup',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule, MatButtonModule, MatDialogModule],
  styles: [
    `
    .dropdown {
      width: 100%;
      margin-top: 16px;
    }
  `
  ],
  template: `
  <h1 mat-dialog-title class="perse-dialog-title">{{ data.header }}</h1>
    <mat-dialog-content>
    <p>{{ data.message }}</p>
    <!-- Show dropdown if dropdownOptions are provided -->
    @if (dropdownControl) {
        <mat-form-field appearance="fill" class="dropdown">
            <mat-label>Select an option</mat-label>
            <mat-select [formControl]="dropdownControl">
                @for (option of data.dropdownOptions; track $index) {
                    <mat-option [value]="option.value">{{ option.display }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
     }
    </mat-dialog-content>
    <mat-dialog-actions>
    <!-- Show Yes/No buttons if userActionType is 'YesOrNo' -->
     @if (data.userActionType === 'YesOrNo') {
        <button mat-button (click)="onCancel()">No</button>
        <button mat-button (click)="onConfirm()" cdkFocusInitial>Yes</button>
    } @else if (data.userActionType === 'Confirm') {
        <button mat-button (click)="onConfirm()" cdkFocusInitial>Ok</button>
    }
    </mat-dialog-actions>
`,
})
export class GenericPopupComponent {
   dropdownControl: FormControl | null = null;

  constructor(
    public dialogRef: MatDialogRef<GenericPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopupData
  ) {
    if(data.dropdownOptions) {
      this.dropdownControl = new FormControl(data.dropdownOptions[0].value);
    }
  }

  onConfirm(): void {
    if (this.dropdownControl) {
        const selectedValue = this.dropdownControl.value; // Get the selected dropdown value
        this.dialogRef.close({ confirmed: true, selectedValue }); // Return confirmation and selected value
    } else {
        this.dialogRef.close(true); // Return true for confirmation
    }
  }

  onCancel(): void {
    if(this.dropdownControl) {
        this.dialogRef.close({ confirmed: false, selectedValue: null }); // Return cancellation
    } else {
        this.dialogRef.close(false); // Return false for cancellation
    }
  }
}